export default __webpack_public_path__ + "components/03-features/brand/header/header.html.twig";